import React, { FC, useMemo } from 'react';
import BottomSheet from '@/components/Common/DesignSystem/BottomSheet/BottomSheet';
import { observer } from 'mobx-react-lite';
import styles from './index.module.scss'

interface INolBottomSheet {
  isOpen: boolean;
  onRequestClose: () => void;
  title: string;
  body: {
    title?: string;
    description?: string;
  };
  button: {
    label: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
  };
}

const NolBottomSheet: FC<INolBottomSheet> = ({ isOpen, onRequestClose, title, body, button }) => {
  const _body = useMemo(() => {
    return (
      <div className={styles.bodyContainer}>
        {body.title && <div className={styles.bodyTitle}>{body.title}</div>}
        {body.description && <div className={styles.bodyDescription}>{body.description}</div>}
      </div>
    );
  }, []);
  return (
    <BottomSheet isOpen={isOpen} onRequestClose={onRequestClose}>
      {{
        title,
        body: _body,
        buttons: {
          type: 'confirm',
          style: 'primary',
          label: button.label,
          onClick: button.onClick,
        },
      }}
    </BottomSheet>
  );
};

export default observer(NolBottomSheet);
